import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Constants } from '../app.constants';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SthandarshanService {

  constructor(private httpClient: HttpClient) { }

  get(): Observable<AllSthanLocation> {
    return this.httpClient.get<AllSthanLocation>(Constants.allsthan);
  }
}

export class AllSthanLocation {
  cities: Cities[] = [];
  talukas: Talukas[] = [];
  villages: Villages[] = [];
  geolocations: Geolocations[] = [];
}

export class Cities {
  cityid = 0;
  statesid = 0;
  name = "";
  marathiname = "";
}

export class Talukas {
  talukaid = 0;
  cityid = 0;
  name = "";
  marathiname = "";
}

export class Villages {
  villageid = 0;
  talukaid = 0;
  name = "";
  info = "";
  marathiname = "";
  latitude = "";
  longitude = "";

}

export class Geolocations {
  id = 0;
  villageId = 0;
  googleName = "";
  marathiName = "";
  latitude = "";
  longitude = "";
  village = "";
}

